<div class="popinfo">
	<button class="popinfo-close" (click)="onClose()">
		<svg class="popinfo-close--icon">
			<use xlink:href="assets/sprites/sprite.svg#close"></use>
		</svg>
	</button>

	<div class="popinfo-body" *ngIf="translationParams">
		<p class="popinfo-body--title">
			{{'SATISFACTIONPOPUP.TITLE' | translate | uppercase}}
			<strong>{{currentUser | defMemberName: 'firstName' | uppercase}}</strong>
		</p>
		<div [innerHTML]="'SATISFACTIONPOPUP.COURSEINSTANCEBODY' | translate:translationParams"
				 class="popinfo-body--content"
				 *ngIf="translationParams?.hasOwnProperty('course')"></div>
		<a routerLink="me/formation"
			 *ngIf="translationParams?.hasOwnProperty('course')"
			 (click)="onClose()"
			 class="popinfo-body--content">
			{{ 'ME.TITLE' | translate }} -> {{ 'ME.SIDEMENU.FORMATION' | translate }}
		</a>

		<div [innerHTML]="'SATISFACTIONPOPUP.ROOMBOOKINGBODY' | translate:translationParams"
				 class="popinfo-body--content"
				 *ngIf="translationParams?.hasOwnProperty('room')"></div>
		<a routerLink="me/reservation"
			 *ngIf="translationParams?.hasOwnProperty('room')"
			 (click)="onClose()"
			 class="popinfo-body--content">
			{{ 'ME.TITLE' | translate }} -> {{ 'ME.SIDEMENU.RESERVATION' | translate }}
		</a>
	</div>

	<div class="popinfo-footer" *ngIf="translationParams">
		<button mat-flat-button
						color='primary'
						(click)='onValid()'
						class='popinfo-footer--button'>
			{{'SATISFACTIONPOPUP.BUTTON' | translate | uppercase}}
		</button>
	</div>

	<mat-spinner *ngIf="!translationParams" diameter="50"></mat-spinner>
</div>
